import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgInDelivery32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M27.232 22.3 20.417 27h-7.633L8.23 25.7V27H4v-9.55h4.554V5h17.88v14.01c.435.08.839.31 1.142.67.686.82.514 2-.334 2.63zM7.231 18.45H5V26h2.23zM19.76 6h-4.534v4.56l2.272-.85 2.272.85V6zm5.674 0H20.76v6l-3.27-1.22L14.217 12V6H9.543v11.46c1.363.09 2.656.63 3.645 1.55h3.271c.99 0 1.919.64 2.13 1.63.112.53 0 1.03-.252 1.43h1.272l5.513-2.89c.101-.05.202-.09.313-.13zm1.363 14.31c-.282-.34-.797-.45-1.221-.24l-5.715 3h-6.109v-1h2.777c.717 0 1.222-.62 1.09-1.23-.09-.46-.555-.84-1.15-.84h-3.686l-.141-.15c-.899-.9-2.161-1.41-3.494-1.41H8.23v6.21l4.685 1.34h7.19l6.552-4.51c.404-.3.454-.82.151-1.18zm-15.195-5.66h3.412v1h-3.412z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgInDelivery32);
export default Memo;